"use strict";import{Picker as e}from"./src/Picker.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-picker",e);
//# sourceMappingURL=sp-picker.js.map
